<section class="py-4">
  <div class="row mx-lg-2">
    <div class="col-3 px-3 pb-2">
      <label for="">#ID</label>
      <input [formControl]="pesquisaId" type="text" class="form-control text-uppercase">
    </div>
    <div class="col-3 px-3 pb-2">
      <label for="">Usuário</label>
      <input [formControl]="pesquisaUsuario" type="text" class="form-control text-uppercase">
    </div>
    <div class="col-3 px-3 pb-2">
      <label for="">Chave da consulta</label>
      <input [formControl]="pesquisaChave" type="text" class="form-control text-uppercase">
    </div>
    <div class="col-3 px-3 pb-2">
      <label for="">Status</label>
      <select [formControl]="pesquisaStatus" class="form-control" name="" id="">
        <option *ngFor="let status of listaStatus" [value]="status.codigo">{{status.nome}}</option>
      </select>
    </div>
    <div class="col-12 px-3 pb-2">
      <app-date-interval [(inicio)]="filter.filter.dataInicio" [(fim)]="filter.filter.dataFim"></app-date-interval>
    </div>
    <div *ngIf="exibirHistoricoGeral" class="col-12 px-3 pb-2 ">
      <label for="pesquisaConsulta">Cliente</label>
      <div class="d-flex align-items-center autocomplete-container">
        <input [inputFormatter]="inputClienteFormat" (selectItem)="addFiltroUnidade($event)"
          [(ngModel)]="unidadeSelecionada" [ngbTypeahead]="pesquisaCliente" [resultTemplate]="rt_cliente"
          id="pesquisaCliente" type="text" class="form-control">
        <button *ngIf="filter.filter.cliente!=null" (click)="removeFiltroUnidade()"
          class="btn btn-xs btn-danger btn-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <ng-template #rt_cliente let-r="result" let-t="term">
        <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
      </ng-template>
    </div>
    <div class="col-12 pb-2 px-3">
      <label for="pesquisaConsulta">Escolha a consulta</label>
      <div class="row align-items-center">

        <ng-container *ngFor="let c of listaTipoConsulta">
          <button *ngIf="c.checked" (click)="removeFiltroConsulta(c)" class="btn btn-sm btn-danger btn-icon m-1">
            <span> {{ c.nomeConsulta }}</span>
            <i class="mdi mdi-close"></i>
          </button>
        </ng-container>
        <input [inputFormatter]="inputConsultaFormat" (selectItem)="addFiltroConsulta($event)"
          [(ngModel)]="consultaSelecionada" [ngbTypeahead]="pesquisaConsulta" [resultTemplate]="rt_consulta"
          id="pesquisaConsulta" type="text" class="form-control input-autocomplete">
        <ng-template #rt_consulta let-r="result" let-t="term">
          <ngb-highlight [result]="r.nomeConsulta" [term]="t"></ngb-highlight>
        </ng-template>
        <button class="btn btn-md px-5 btn-primary marginLeft" (click)="getHistoricoGeral()">
          <span>Pesquisar</span>
        </button>
      </div>
    </div>
  </div>

  <div class="col-2 col-sm p-1" *ngIf="tableLoading && exibeBotaoMaluco" >
    <button (click)="verConsulta()" class="btn btn-theme btn-sm btn-icon w-100">
      <i class="mdi mdi-eye"></i>Resultado
      <span> -- Clique aqui para visualizar o Resultado -- </span>
    </button>
  </div>

  <div *ngIf="tableLoading" class="m-3 m-lg-4 card">
    <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>



  <div *ngIf="!tableLoading" class="m-3 m-lg-4 card">
    <div class="table-responsive-lg">
      <div class="row" *ngIf="!exibirHistoricoGeral">
        <p-table #dt [columns]="cols"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
          [value]="listaConsultas" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
          [(selection)]="object_list" [first]="first">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.idConsultaVeiculo" (tableOrderChange)="getHistorico()" width="8%">Id</th>
              <th class="d-none d-sm-table-cell" [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.nomeUsuario" (tableOrderChange)="getHistorico()" width="30%">Usuario</th>
              <th width="26%">Chave da consulta</th>
              <th width="20%">Consulta</th>
              <th [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.dataCriacao" class="text-center d-none d-sm-table-cell" (tableOrderChange)="getHistorico()" width="10%">Data</th>
              <th width="6%">Ações</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td>{{rowData.id}}</td>
              <td class="d-none d-sm-table-cell">{{rowData.usuario.nome | uppercase}}</td>

              <td class="text-truncate text-center text-uppercase">
                <ng-container *ngFor="let e of rowData?.listaChaveEntrada">
                  <div *ngIf="e.tipo == 'PLACA'">{{e.chaveEntrada | appPlaca}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'CHASSI'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'DOCUMENTO'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'CRLV'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'CNH'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'RENAVAM'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'MOTOR'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                </ng-container>
              </td>

              <td class="pt-1">
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <ng-container *ngFor="let c of rowData.listaInsumo">
                    <div class="mb-1">
                      <h2>
                        <span class="badge badge-pill break-line" [ngClass]="{
                          'badge-success' : c.codigoControle!='ERRO_FORNECEDOR',
                          'badge-danger' : c.codigoControle=='ERRO_FORNECEDOR'
                        }">{{c.nomeConsulta | uppercase}}</span>
                      </h2>
                    </div>
                      <!-- <i class="mdi" [ngClass]="{
                  'mdi-check' : c.codigoControle.status!=100,
                  'mdi-exclamation' : c.codigoControle.status==100
                }"></i> -->
                  </ng-container>
                </div>
              </td>
              <!-- <td class="pt-1">
                <div class="row align-items-center">
                  <ng-container *ngFor="let c of rowData.listaInsumo">
                    <div class="tag bg-success mr-1 mb-1" [ngClass]="{
                      'bg-success' : c.codigoControle=='OK' || c.codigoControle=='SEMREGISTRO_OK' || c.codigoControle=='SEMREGISTRO_NAO_COBRAR',
                      'bg-danger' : c.codigoControle=='ERRO_FORNECEDOR' || c.codigoControle=='INDISPONIVEL' || c.codigoControle=='SEMREGISTRO_NAOCONFIAR' || c.codigoControle=='ERRO_TIMEOUT',
                      'bg-warning' : c.codigoControle=='PENDENTE' || c.codigoControle=='PARCIALMENTE_OK'
                    }">
                      <span>{{c.nomeConsulta}}</span>
                      <i class="mdi" [ngClass]="{
                    'mdi-check' : c.codigoControle.status!=100,
                    'mdi-exclamation' : c.codigoControle.status==100
                  }"></i>
                    </div>
                  </ng-container>
                </div>
              </td> -->

              <td class="text-center d-none d-sm-table-cell">{{rowData.dataConsulta | date:'dd/MM/yyyy HH:mm'}}</td>
              <td>
                <div>
                  <span data-toggle="tooltip" data-placement="bottom" title="Visualizar">
                    <a [routerLink]="['/consulta','resultado-cliente', rowData.tokenConsulta || rowData.id]"
                      rel="noopener noreferrer" target="_blank" class="btn btn-sm btn-info btn-icon">
                      <i class="mdi mdi-eye"></i>
                    </a>
                  </span>
                  <hr/>
                  <span data-toggle="tooltip" data-placement="bottom" title="Imprimir">
                    <span (click)="printPdf(rowData.tokenConsulta)" class="btn btn-sm btn-info btn-icon">
                      <i class="mdi mdi-file"></i>
                    </span>
                  </span>
                </div>
              </td>

              <!-- <td class="py-1 alignCenter">


                <div class="d-flex align-items-center justify-content-center" style=" margin-top:25px;">
                  <span data-toggle="tooltip" data-placement="bottom" title="Visualizar"  >
                    <a [routerLink]="['/consulta','resultado-cliente', rowData.tokenConsulta || rowData.id]"
                      rel="noopener noreferrer" target="_blank" class="btn btn-sm btn-info btn-icon">
                      <i class="mdi mdi-eye"></i>
                    </a>
                  </span>
                  <hr/>
                  <span data-toggle="tooltip" data-placement="bottom" title="Imprimir"  style=" margin-left:3px;">
                    <span (click)="printPdf(rowData.tokenConsulta)" class="btn btn-sm btn-info btn-icon">
                      <i class="mdi mdi-file"></i>
                    </span>
                  </span>
                </div>
              </td> -->


            </tr>
          </ng-template>
          <ng-template pTemplate="footer" let-columns *ngIf="listaConsultas != null && listaConsultas.length > 0">
            <div class="card-footer bg-white row justify-content-between minPage550">
              <div class="pb-2 pb-sm-0">
                <ngb-pagination [pageSize]="filter.per_page" [boundaryLinks]="true" [collectionSize]="total"
                  [(page)]="this.filter.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
                </ngb-pagination>
              </div>
              <div class="pb-2 pb-sm-0">
                <div class="btn-group" role="group">
                  <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                      class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom"></button></span>
                  <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  filter.per_page==10}"
                    type="button" class="btn btn-outline-primary">10</button>
                  <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  filter.per_page==25}"
                    type="button" class="btn btn-outline-primary">25</button>
                  <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  filter.per_page==50}"
                    type="button" class="btn btn-outline-primary">50</button>
                  <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active':  filter.per_page==100}"
                    type="button" class="btn btn-outline-primary">100</button>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                Nenhuma consulta foi encontrada com os filtros informados
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="row" *ngIf="exibirHistoricoGeral">
        <p-table #dt [columns]="cols2"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
          [value]="listaConsultas" selectionMode="single" [(selection)]="object_list" [first]="first">

          <ng-template pTemplate="header" let-columns>
            <tr>
                <th [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.idConsultaVeiculo" (tableOrderChange)="getHistorico()" width="8%">Id</th>
                <th class="d-none d-sm-table-cell" [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.razaosocial" *ngIf="exibirHistoricoGeral" (tableOrderChange)="getHistorico()" width="20%">Cliente</th>
                <th class="d-none d-sm-table-cell" [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.nomeUsuario" (tableOrderChange)="getHistorico()" width="20%">Usuario</th>
                <th width="20%">Chave da consulta</th>
                <th width="16%">Consulta</th>
                <th class="d-none d-sm-table-cell" [tableOrderGroup]="filter.filter.order" [(tableOrder)]="filter.filter.order.dataCriacao" (tableOrderChange)="getHistorico()" width="10%">Data</th>
                <th width="6%">Ações</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td>{{rowData.id}}</td>
              <td class="d-none d-sm-table-cell" >{{rowData.unidade.nomeFantasia | uppercase}}</td>
              <td class="d-none d-sm-table-cell" >{{rowData.usuario.nome | uppercase}}</td>

              <td class="text-truncate text-center text-uppercase">
                <ng-container *ngFor="let e of rowData?.listaChaveEntrada">
                  <div *ngIf="e.tipo == 'PLACA'">{{e.chaveEntrada | appPlaca}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'CHASSI'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'DOCUMENTO'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'CRLV'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'CNH'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'RENAVAM'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                  <div *ngIf="e.tipo == 'MOTOR'">{{e.chaveEntrada}} {{(e.chaveEntrada != '') ? '(' + e.tipo + ')' : ''}}</div>
                </ng-container>
              </td>
              <td class="pt-1">
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <ng-container *ngFor="let c of rowData.listaInsumo">
                    <div class="mb-1">
                      <h2>
                        <span class="badge badge-pill break-line" [ngClass]="{
                          'badge-success' : c.codigoControle!='ERRO_FORNECEDOR',
                          'badge-danger' : c.codigoControle=='ERRO_FORNECEDOR'
                        }">{{c.nomeConsulta | uppercase}}</span>
                      </h2>
                    </div>
                      <!-- <i class="mdi" [ngClass]="{
                  'mdi-check' : c.codigoControle.status!=100,
                  'mdi-exclamation' : c.codigoControle.status==100
                }"></i> -->
                  </ng-container>
                </div>
              </td>
              <td class="text-center d-none d-sm-table-cell">{{rowData.dataConsulta | date:'dd/MM/yyyy HH:mm'}}</td>
              <td>
                <div>
                  <span data-toggle="tooltip" data-placement="bottom" title="Visualizar">
                    <a [routerLink]="['/consulta','resultado-cliente', rowData.tokenConsulta || rowData.id]"
                      rel="noopener noreferrer" target="_blank" class="btn btn-sm btn-info btn-icon">
                      <i class="mdi mdi-eye"></i>
                    </a>
                  </span>
                  <hr/>
                  <span data-toggle="tooltip" data-placement="bottom" title="Imprimir">
                    <span (click)="printPdf(rowData.tokenConsulta)" class="btn btn-sm btn-info btn-icon">
                      <i class="mdi mdi-file"></i>
                    </span>
                  </span>
                </div>
              </td>


            </tr>
          </ng-template>
          <ng-template pTemplate="footer" let-columns *ngIf="listaConsultas != null && listaConsultas.length > 0">
            <div class="card-footer bg-white row justify-content-between minPage650">
              <div class="pb-2 pb-sm-0">
                <ngb-pagination [pageSize]="filter.per_page" [boundaryLinks]="true" [collectionSize]="total"
                  [(page)]="this.filter.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
                </ngb-pagination>
              </div>
              <div class="pb-2 pb-sm-0">
                <div class="btn-group" role="group">
                  <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                      class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom">
                    </button>
                  </span>
                  <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  filter.per_page==10}"
                    type="button" class="btn btn-outline-primary">10</button>
                  <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  filter.per_page==25}"
                    type="button" class="btn btn-outline-primary">25</button>
                  <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  filter.per_page==50}"
                    type="button" class="btn btn-outline-primary">50</button>
                  <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active':  filter.per_page==100}"
                    type="button" class="btn btn-outline-primary">100</button>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                Nenhuma consulta foi encontrada com os filtros informados
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</section>
